import httpClient from '../../utilities/http/http-client';

const endPoint = '/v1/web/auth';
const endPoint2 = '/v1/web/admin/auth';

export default {
  checkAuth(params = {}) {
    return httpClient.post(endPoint + '/check-auth', params);
  },
  login(params = {}) {
    return httpClient.post(endPoint + '/login', params);
  },
  logout(params = {}) {
    return httpClient.post(endPoint2 + '/logout', params);
  },
  changePassword(params = {}) {
    return httpClient.post(endPoint2 + '/update-password', params);
  },
};
